import { Injectable } from '@angular/core';
import { CurrencyDto } from '@osos/shared/api';
import { CurrencyPresenterModel } from '@osos/shared/types';
import { FactoryBase } from '../../bases/factory/factory-base';
import { CurrencyParserV1Service } from '../../parsers/index';
import { ParserFactory } from '../../services';

@Injectable()
export class CurrencyEntryFactoryService extends FactoryBase<
  CurrencyDto,
  CurrencyPresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: CurrencyParserV1Service,
  ) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }

  createDataModel(presenter: CurrencyPresenterModel): CurrencyDto {
    const parser = this.getParser(CurrencyDto, CurrencyPresenterModel);
    return parser.getDataModel(presenter);
  }

  createPresenterModel(model: CurrencyDto): CurrencyPresenterModel {
    const parser = this.getParser(CurrencyDto, CurrencyPresenterModel);
    return parser.getPresenterModel(model);
  }
}
